<template>
  <div>

    <div class="container py-3">

      <div class="p-3 bg-white rounded shadow pb-0">

        <div class="row">
          <div class="col-12">

            <div class="d-flex">
              <h3 class="text-dark font-weight-bolder mr-auto mb-0"><span class="badge badge-pill badge-primary">Crew Search</span>
              </h3>

              <div>
                <div class="input-group form-inline justify-content-between">
                  <div class="input-group border rounded-pill p-1 mb-3">
                    <input type="search"
                           placeholder="Search .. "
                           aria-describedby="button-addon3"
                           class="form-control ml-1 bg-none border-0"
                           v-model="formCrewData.search">
                    <div class="input-group-append border-0">
                      <button id="button-addon3" type="button" class="btn btn-link text-primary">
                        <font-awesome-icon icon="search"/>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <table class="table">
              <thead class="thead-light">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Crew IPN</th>
                <th scope="col">Last Name</th>
                <th scope="col">First Name</th>
                <th scope="col">Middle Name</th>
                <th scope="col">Manning</th>
                <th scope="col">Action</th>
              </tr>
              </thead>

              <tbody v-if="isLoading">
              <tr>
                <td colspan="100%">
                  <base-loader></base-loader>
                </td>
              </tr>
              </tbody>

              <tbody>
              <tr v-for="(crew,index) in crews" :key="crew.id" style="font-size: 14px;">
                <th scope="row">{{ index + 1 }}</th>
                <td>{{ crew.crew_ipn }}</td>
                <td>{{ crew.last_name }}</td>
                <td>{{ crew.first_name }}</td>
                <td>{{ crew.middle_name }}</td>
                <td>{{ crew.manning }}</td>
                <td>
                  <button class="btn btn-dark btn-sm" style="font-size: 12px;" @click="viewCrewLogs(crew.id);"
                          v-if="crew.crew_count_logs !== 0">
                    <font-awesome-icon icon="clipboard-check"/>
                    View Logs
                  </button>
                  <button class="btn btn-danger btn-sm" style="font-size: 12px;" v-if="crew.crew_count_logs === 0">
                    <font-awesome-icon icon="file"/>
                    No Logs
                  </button>
                </td>
              </tr>

              </tbody>
            </table>

            <div class="row">
              <div class="col-lg-12 d-flex d-flex justify-content-center">
                <base-pagination :page-object="crewPagination" @settingPage="setPage"></base-pagination>
              </div>
            </div>


          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {AppMixins} from '@/mixins/app.mixins';
import axios from 'axios';

export default {
  name: 'CrewSearch',

  /**mixins**/
  mixins: [AppMixins],

  /**data**/
  data() {
    return {
      loading: false,
    };
  },

  /**methods**/
  methods: {
    ...mapActions([
      // 'getCrewList',
      'set_crew_paginated',
      'getCrewLogs',
    ]),

    setPage(e) {
      this.formCrewData.page = e;
      // this.userPagination.currentPage = e;
      this.updateParams();
    },

    async updateParams() {
      await this.set_crew_paginated(this.formCrewData);
    },

    viewCrewLogs(__crewId) {
      this.getCrewLogs(__crewId);
      this.$nextTick(() => {
        this.$router.push({name: 'CrewLog', params: {crewId: __crewId}});
      });
    },

  },

  watch: {
    'formCrewData.search'() {
      this.paginateCrew();
    },

  },

  /**  computed  **/
  computed: {
    ...mapGetters(
        [
          'isLoading',
          'crews',
          'formCrewData',
          'crewPagination',
        ],
    ),

  },

  created() {
    // this.getCrewList();
    this.set_crew_paginated(this.formCrewData);
    this.paginateCrew = _.debounce(this.updateParams, 500);
  },

  mounted() {
  },

};
</script>

<style scoped>

/*Search*/
.form-control:focus {
  box-shadow: none;
}

.form-control-underlined {
  border-width: 0;
  border-bottom-width: 1px;
  border-radius: 0;
  padding-left: 0;
}


.form-control::placeholder {
  font-size: 0.95rem;
  color: #007bff;
  font-style: italic;
}
</style>
